import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { DynamicLink } from '@/components/functional/Link/DynamicLink';
import { ImageBase } from '@/components/ui/Image/ImageBase';
import { Text } from '@/components/ui/Typography/Body/Text';
import { professionalUnitPath } from '@/utils/router/links';
/**
 * セミナー：組織情報のコンポーネント
 * @param props
 * @constructor
 */
export const SeminarCliOrganization = (props) => {
    const { className, logo = '', name, urlCode } = props;
    return (_jsxs(DynamicLink, Object.assign({ className: clsx('inline-flex items-center', 'gap-x-12', className), noLinkElement: urlCode ? undefined : 'div', target: '_blank', to: urlCode ? professionalUnitPath(urlCode) : '' }, { children: [_jsx(Text, Object.assign({ color: 'textGray', size: 'xs' }, { children: name })), logo && (_jsx(ImageBase, { alt: name, objectPosition: 'contain', pictureClassName: clsx('flex justify-center items-center', 'w-[94px] h-[35px]'), src: logo }))] })));
};
